/** Card "Aniversário" no Perfil: a data é da conta; entra no cadastro e se ajusta aqui. */
import { useState } from 'react';

import { useGuardarNascimento, useMeuNascimento } from './api';

export function NascimentoNoPerfil() {
  const meu = useMeuNascimento();
  const guardar = useGuardarNascimento();
  // null = ainda não mexeu: mostra o que veio do servidor. A folha monta antes de a
  // consulta voltar, e a resposta não pode apagar o que a pessoa já digitou.
  const [editado, setEditado] = useState<string | null>(null);
  const valor = editado ?? meu.data?.birthDate ?? '';
  const mudou = (meu.data?.birthDate ?? '') !== valor;

  return (
    <>
      <label className="field">
        <span className="field__label">Data de nascimento</span>
        <input className="field__input" type="date" value={valor} onChange={(e) => setEditado(e.target.value)} aria-label="Data de nascimento" data-testid="nascimento" />
      </label>
      {guardar.isError && <p className="auth-error" role="alert">{guardar.error instanceof Error ? guardar.error.message : 'Não deu para guardar.'}</p>}
      <div className="fin__ctas">
        {meu.data?.birthDate && (
          <button type="button" className="nv-btn nv-btn--secondary" disabled={guardar.isPending} onClick={() => guardar.mutate(null, { onSuccess: () => setEditado(null) })}>
            Apagar
          </button>
        )}
        <button type="button" className="nv-btn nv-btn--primary" disabled={!mudou || !valor || guardar.isPending} onClick={() => guardar.mutate(valor)} data-testid="guardar-nascimento">
          {guardar.isPending ? 'Guardando…' : guardar.isSuccess && !mudou ? 'Guardado' : 'Guardar'}
        </button>
      </div>
    </>
  );
}
